import { render, staticRenderFns } from "./cityPage.vue?vue&type=template&id=b4566c4e"
import script from "./cityPage.vue?vue&type=script&lang=js"
export * from "./cityPage.vue?vue&type=script&lang=js"
import style0 from "./cityPage.vue?vue&type=style&index=0&id=b4566c4e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PlaceCard: require('/workspace/components/PlaceCard.vue').default,ActivityBlog: require('/workspace/components/ActivityBlog/ActivityBlog.vue').default,EventCardGeneral: require('/workspace/components/EventCardGeneral.vue').default,RestaurantCard: require('/workspace/components/RestaurantCard.vue').default,StayCard: require('/workspace/components/StayCard.vue').default,ExploreCardV2: require('/workspace/components/ExploreCardV2.vue').default,RentalCardV3: require('/workspace/components/RentalCardV3.vue').default})
